export const getJsonItem = (data, key, value) => {
    if (data == null || value == null) {
        return null;
    }

    for (let item of data) {
        if (item[key] != null && item[key].toString() === value.toString()) {
            return item;
        }
    }

    return null;
}

export const getJsonItemInvariantCase = (data, key, value) => {
    if (data == null) {
        return null;
    }
    
    for (let item of data) {
        if (item[key] != null && item[key].toLowerCase() === value.toLowerCase()) {
            return item;
        }
    }

    return null;
}

export const getUniqueValues = (data, key) => {
    if (data == null) {
        return null;
    }

    var unique = [];

    for (let item of data) {
        if (item[key] != null && item[key] !== "" && !unique.map((x) => { return x.toLowerCase() }).includes(item[key].toLowerCase())) {
            unique.push(item[key]);
        }
    }

    return unique;
}

export const isEmpty = (obj) => {
    if (obj == null) {
        return true;
    }

    if (typeof obj === "string" && obj.trim() === "") {
        return true;
    }

    return false;
}

export const getJsonDate = (dateString) => {
    if (dateString == null) {
        return null;
    }
    
    return new Date(dateString);
}

export const getDateString = (date) => {
    if (date == null) {
        return "";
    }

    var day = date.getDate();
    var month = date.getMonth() + 1;
    var year = date.getFullYear();

    var dayString = "00".substring(0, 2 - day.toString().length) + day;
    var monthString = "00".substring(0, 2 - month.toString().length) + month;

    return dayString + "/" + monthString + "/" + year;
}

export const getMonthYearString = (date) => {
    if (date == null) {
        return "";
    }

    var month = date.getMonth() + 1;
    var year = date.getFullYear();

    var monthString = "00".substring(0, 2 - month.toString().length) + month

    return monthString + "/" + year;
}

export const getTimeString = (date) => {
    if (date == null) {
        return "";
    }

    var hour = date.getHours();
    var minute = date.getMinutes();

    var hourString = "00".substring(0, 2 - hour.toString().length) + hour;
    var minuteString = "00".substring(0, 2 - minute.toString().length) + minute;

    return hourString + ":" + minuteString;
}

export const groupBy = (xs, key) => {
    return xs.reduce(function(rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
    }, Object.create(null));
};

/*eslint no-extend-native: 0*/
Object.defineProperty(Array.prototype, 'group', {
    enumerable: false,
    value: function (key) {
        let map = {};
        this.map(e => ({k: key(e), d: e})).forEach(e => {
            map[e.k] = map[e.k] || [];
            map[e.k].push(e.d);
        });
        return Object.keys(map).map(k => ({key: k, data: map[k]}));
    }
});


// WEBPACK FOOTER //
// ./src/Utilities/JsonFunctions.js